export default "__VITE_ASSET__Cee9F7lI__"